import { useEffect, useState } from 'react';



function VerticalAiBeforeAfterSlider({

  beforeImage,

  afterImage,

  beforeAlt = 'Before',

  afterAlt = 'After',

  fallbackSrc = null,

  showLabels = false,

  beforeLabel = 'Before',

  afterLabel = 'After',

  className = '',

  onCycle,

  nextBeforeImage = null,

  showSrDescription = true,

  beforeLoading = 'lazy',

  afterLoading = 'lazy',

  beforeFetchPriority,

  afterFetchPriority,

  imageWidth = 1024,

  imageHeight = 683,

}) {

  const [beforeError, setBeforeError] = useState(false);

  const [afterError, setAfterError] = useState(false);



  useEffect(() => {

    setBeforeError(false);

    setAfterError(false);

  }, [beforeImage, afterImage]);



  if (beforeError || afterError) {

    const src = fallbackSrc || beforeImage;

    if (!src) return null;

    return (

      <img

        src={src}

        alt={beforeAlt}

        className="vertical-ai-before-after__fallback-img"

        loading={beforeLoading}

        decoding="async"

        width={imageWidth}

        height={imageHeight}

        {...(beforeFetchPriority ? { fetchPriority: beforeFetchPriority } : {})}

      />

    );

  }



  const rootClass = ['vertical-ai-before-after', className].filter(Boolean).join(' ');

  const handleCycle = (event) => {
    if (!onCycle) return;
    if (nextBeforeImage && event.animationName !== 'bacsCinematicScanReveal') return;
    onCycle(event);
  };



  return (

    <div className={rootClass}>

      <div className="vertical-ai-before-after__stage">

        <img

          src={beforeImage}

          alt=""

          aria-hidden="true"

          className="vertical-ai-before-after__img vertical-ai-before-after__img--before"

          loading={beforeLoading}

          decoding="async"

          width={imageWidth}

          height={imageHeight}

          {...(beforeFetchPriority ? { fetchPriority: beforeFetchPriority } : {})}

          onError={() => setBeforeError(true)}

        />

        {nextBeforeImage ? (

          <img

            src={nextBeforeImage}

            alt=""

            aria-hidden="true"

            className="vertical-ai-before-after__img vertical-ai-before-after__img--next-before"

            loading={beforeLoading}

            decoding="async"

            width={imageWidth}

            height={imageHeight}

            {...(beforeFetchPriority ? { fetchPriority: beforeFetchPriority } : {})}

          />

        ) : null}

        <div

          className="vertical-ai-before-after__after-wrap"

          onAnimationIteration={handleCycle}

        >

          <img

            src={afterImage}

            alt=""

            aria-hidden="true"

            className="vertical-ai-before-after__img vertical-ai-before-after__img--after"

            loading={afterLoading}

            decoding="async"

            width={imageWidth}

            height={imageHeight}

            {...(afterFetchPriority ? { fetchPriority: afterFetchPriority } : {})}

            onError={() => setAfterError(true)}

          />

        </div>

        <div className="vertical-ai-before-after__laser" aria-hidden="true" />

        {showLabels ? (

          <>

            <span className="vertical-ai-before-after__label vertical-ai-before-after__label--before">

              {beforeLabel}

            </span>

            <span className="vertical-ai-before-after__label vertical-ai-before-after__label--after">

              {afterLabel}

            </span>

          </>

        ) : null}

      </div>

      {showSrDescription ? (

        <span className="vertical-ai-before-after__sr-only">

          {beforeAlt}. {afterAlt}.

        </span>

      ) : null}

    </div>

  );

}



export default VerticalAiBeforeAfterSlider;

